// extracted by mini-css-extract-plugin
export default {"wrapper":"Gn-z","viewport":"Hn-z","container":"In-z","slide":"Jn-z"};